import { Routes } from '@angular/router';

// Guards
import { AuthGuard } from './core/guard/auth.guard';

// Layout components
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/auth/login',
        pathMatch: 'full',
    },
    {
        path: 'auth',
        component: AuthLayoutComponent,
        loadChildren: () => import('./module/auth/auth.routes').then((m) => m.AUTH_ROUTES),
    },
    {
        path: '',
        component: ContentLayoutComponent,
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
        children: [
            {
                path: 'dashboard',
                loadChildren: () => import('./module/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
            },
            {
                path: 'profile',
                loadChildren: () => import('./module/profile/profile.routes').then((m) => m.PROFILE_ROUTES),
            },
            {
                path: 'companies',
                loadChildren: () => import('./module/company/company.routes').then((m) => m.COMPANY_ROUTES),
            },
            {
                path: 'contacts',
                loadChildren: () => import('./module/contact/contact.routes').then((m) => m.CONTACT_ROUTES),
            },
            {
                path: 'contracts',
                loadChildren: () => import('./module/contract/contract.routes').then((m) => m.CONTRACT_ROUTES),
            },
            {
                path: 'installation-records',
                loadChildren: () => import('./module/installation/installation.routes').then((m) => m.INSTALLATION_ROUTES),
            },
            {
                path: 'items',
                loadChildren: () => import('./module/item/item.routes').then((m) => m.ITEM_ROUTES),
            },
            {
                path: 'service-records',
                loadChildren: () => import('./module/service/service.routes').then((m) => m.SERVICE_ROUTES),
            },
            {
                path: 'issue-records',
                loadChildren: () => import('./module/issue/issue.routes').then((m) => m.ISSUE_ROUTES),
            },
            {
                path: 'settings/manage-list-values',
                loadChildren: () => import('./module/list-value/list-value.routes').then((m) => m.LIST_VALUE_ROUTES),
            },
            {
                path: 'settings/check-list',
                loadChildren: () => import('./module/check-list/check-list.routes').then((m) => m.CHECK_LIST_ROUTES),
            },
            {
                path: 'manage/tenant/company',
                loadChildren: () => import('./module/tenant-company/tenant-company.routes').then((m) => m.TENANT_COMPANY_ROUTES),
            },
            {
                path: 'manage/tenant/contact',
                loadChildren: () => import('./module/tenant-contact/tenant-contact.routes').then((m) => m.TENANT_CONTACT_ROUTES),
            },
        ],
    },
];

